import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'

const ClearFilterIcon = props => {
  return (
    <SvgIcon {...props}>
      <path d="M4.12852 3C2.55632 3 1.68225 4.81862 2.66439 6.0463L6.63258 11.0065V14.5587C6.63258 14.9673 6.85409 15.3437 7.21123 15.5421L9.08623 16.5838C9.83608 17.0004 10.7576 16.4582 10.7576 15.6004V11.0065L14.7258 6.0463C15.7079 4.81862 14.8338 3 13.2616 3H4.12852Z" />
      <path
        d="M15.1933 11.3787L13.072 13.5L15.3864 15.8143L12.9277 18.273L15.0491 20.3943L17.5077 17.9356L19.9663 20.3943L22.0876 18.273L19.629 15.8143L21.9433 13.5L19.822 11.3787L17.5077 13.693L15.1933 11.3787Z"
        fill="#FF0000"
      />
    </SvgIcon>
  )
}

export default ClearFilterIcon
